import { createSlice } from '@reduxjs/toolkit';

export const crmAutoFill = createSlice({
  name: 'CRM_AUTOFILL',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    setCrmDecryptedData(state, action) {
      const { payload } = action;
      const { decryptedData } = payload;
      state.decryptedData = decryptedData;
    },

    decryptCrmDataFailed(state) {
      state.decryptedData = null;
    },
  },
});

const { actions, reducer } = crmAutoFill;

export const { setCrmDecryptedData, decryptCrmDataFailed } = actions;

export default reducer;
